import { useMemo, useState } from "react";
import Spinner from 'react-bootstrap/Spinner';
import { axiosGetWithHeader } from "../../Common/axios";
import { handleClickColor } from "../../Common/Util";

export function KPAspectCuspal ({userData}) {
  const [chartData, setChartData] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Aspecting Cuspal');

  useMemo(() => {
    if(userData===null||userData===undefined) {
      setSpinner(null);
      return;
    }
    var clientId = userData.id;
    axiosGetWithHeader("/chart/aspectingcuspalchart/"+clientId,
      (response)=>{
        setChartData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setChartData([]);
        setSpinner(null);
      }
    );

  }, [userData]);

  const tdwidth = {
    width: "7%",
  };
    return(
      <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        {  
          chartData===null||chartData.length===0?(
            <></>
          ):(
            <>
        <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont">
          <caption class="m-0 p-0" ><h5 class="m-0 p-2">Aspecting House</h5></caption>
          <thead>
            <tr class="p-0 m-0 kplinktr" >
              <th class="m-0 p-1 kptable-td">Planet</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>1</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>2</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>3</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>4</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>5</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>6</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>7</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>8</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>9</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>10</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>11</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>12</th> 
            </tr>
          </thead>
          <tbody>
          {
            chartData.map((planet) => (
                <tr class="p-0 m-0 kplinktr"  onClick={handleClickColor}>
                    <th class="bg-transparent text-start m-0 p-0 ps-1 kptable-td">{planet[0]}</th>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[2]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[3]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[4]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[5]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[6]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[7]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[8]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[9]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[10]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[11]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[12]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[13]}</td>
                </tr>
            ))
        }
            </tbody>  
          </table>
        </>
          )}
          </>
      );
  }